import React, { useState, useEffect, useMemo } from "react";
import "./ProgressBar.css";
import FormulaLogo from "../../../img/homepage/formula-logo.png";


const START_DATE = new Date("2026-08-31T00:00:00"); // start date
const TARGET_DATE = new Date("2027-06-15T00:00:00"); // end date
const NUM_SPARKS = 24;

const ProgressBar = () => {
  const [percentage, setPercentage] = useState(0);

  const sparks = useMemo(
    () =>
      Array.from({ length: NUM_SPARKS }).map(() => {
        // how far the spark travels
        const distance = 18 + Math.random() * 20;
        // random directioning for the sparks
        const angleDeg = Math.random() * 80 - 40;
        const angleRad = (angleDeg * Math.PI) / 180;
        const dx = -distance * Math.cos(angleRad);
        const dy = distance * Math.sin(angleRad);

        return {
          dx,
          dy,
          duration: 400 + Math.random() * 500, // 400–900 ms (timings)
          delay: Math.random() * 400, // 0–400 ms
        };
      }),
    []
  );


  // Update progress every second
  useEffect(() => {
    const updateProgress = () => {
      const now = new Date();
      const total = TARGET_DATE - START_DATE;
      const elapsed = now - START_DATE;

      let raw = 0;
      if (total > 0) {
        raw = (elapsed / total) * 100;
      }

      const safeValue = Math.max(0, Math.min(100, raw));
      setPercentage(safeValue);
    };

    updateProgress();
    const intervalId = setInterval(updateProgress, 1000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="progress-bar-wrapper">
      <div className="progress-bar-track">
        <div
          className="progress-bar-fill"
          style={{ width: `${percentage}%` }}
        />

        <div
          className="progress-bar-icon"
          style={{ left: `${percentage}%` }}
        >
          <div className="spark-emitter">
            {sparks.map((spark, i) => (
              <span
                key={i}
                className="spark"
                style={{
                  "--dx": `${spark.dx}px`,
                  "--dy": `${spark.dy}px`,
                  animationDuration: `${spark.duration}ms`,
                  animationDelay: `-${spark.delay}ms`,
                }}
              />
            ))}
          </div>

          <img src={FormulaLogo} alt="FormulaLogo" />
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
